(ns shared.core.components.toggle
  (:require [shared.core.components.interactive :refer [interactive]]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.components.theme :as theme]
            [shared.core.util :as util]))

(defn toggle [{:keys [val-subscribe form-path form-name]} _]
  (let [on?- (if val-subscribe
               (re/subscribe val-subscribe)
               (when (and form-path form-name)
                 (re/subscribe [:form/val- form-path form-name])))]
    (fn [{:keys [on? on-click container-style style disabled? size]}
         & contents]
      (let [on? (if (and (nil? on?) on?-)
                  @on?-
                  on?)
            clickable? (and (or on-click (and form-path form-name))
                            (not disabled?))
            circle-size (condp = size
                          :small 12
                          20)
            gutter-size (condp = size
                          :small 10
                          14)
            font-size (condp = size
                        :small 14
                        16)]
        [:div {:style (merge {:cursor (if clickable? :pointer :default)
                              :display :flex
                              :align-items :center}
                             (when disabled?
                               {:opacity 0.5})
                             container-style)
               :on-click (when clickable?
                           (fn [e]
                             (when (and form-path form-name)
                               (re/dispatch [:form/change form-path form-name (not on?)]))
                             (when on-click (on-click))
                             (.stopPropagation e)))}
         [interactive :div {:style (merge {:display :flex
                                           :align-items :center
                                           :position :relative
                                           :transition "0.2s"
                                           :height circle-size}
                                          style)
                            :hover-style (when clickable? {:opacity 0.9})}
          [theme/theme
           :div {:style {:background-color (if on?
                                             (style/color :green :base)
                                             (style/color :gray :shade-2))
                         :border-radius "50%"
                         :box-shadow "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)"
                         :position :absolute
                         :top "50%"
                         :left (if on? "100%" 0)
                         :transition "0.3s"
                         :transform (str "translate("
                                         (if on?
                                           "-100%"
                                           "0%")
                                         ", -50%)")
                         :height circle-size
                         :width circle-size}
                 :theme (style/dark-style {:background-color (if on?
                                                               (style/dark-color :primary :base)
                                                               (style/dark-color :background :lighter-1))})}]
          [theme/theme
           :div {:style {:background-color (if on?
                                             (util/hex->rgba (style/color :green :base) 0.4)
                                             (style/color :gray :base))
                         :border-radius (/ gutter-size 2)
                         :height gutter-size
                         :width (* gutter-size 2.5)}
                 :theme (style/dark-style {:background-color (if on?
                                                               (style/dark-color :primary :lighter-2)
                                                               (style/dark-color :surface :lighter-1))})}]]
         (when contents
           (into [:div {:style {:color (style/colors :gray :base)
                                :font-size font-size
                                :line-height 1.3
                                :margin-left 7}}]
                 contents))]))))
